import aiStudioImage from "@/assets/login/ai-studio.webp";
import fullyManagedPlansImage from "@/assets/login/fully-managed-plans.webp";

export interface LoginPromoSlide {
  badge: string;
  body: string;
  headline: string;
  href: string;
  image: string;
}

export const LOGIN_PROMO_SLIDES: LoginPromoSlide[] = [
  {
    badge: "What's new",
    body: "The most hands-off, high-output creative experience we offer. Your team focuses on the business. Ours handles the rest.",
    headline:
      "Let us take over the entire creative process for you with our fully managed plans.",
    href: "https://nlc.com/fully-managed-design",
    image: fullyManagedPlansImage,
  },
  {
    badge: "What's new",
    body: "Say goodbye to spending thousands of dollars on professional assets and let our AI team of experts create them for you.",
    headline:
      "Now offering custom AI asset generation capabilities to cover all your needs.",
    href: "https://nlc.com/our-work/ai-studio",
    image: aiStudioImage,
  },
];
